import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';
import { LessonProgressType, LessonProgressTypeLabel } from 'enums/lesson-progress-type';
import { LessonType } from 'enums/lesson-type';
import { formatMinutes } from 'utils/DateHelper';

const LessonRecord = Record({
  id: '',
  title: '',
  type: '',
  summary: [],
  description: '',
  totalTimeInMinutes: 0,
  courseLeader: {},
  launchUrl: '',
  price: 0,
  progress: 0,
  completedAt: new Date(),
});

export default class Lesson extends LessonRecord {
  static deserialize(jsonObject = {}) {
    if (!jsonObject) {
      return undefined;
    }

    const mapProperties = {};

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new Lesson(hydrated);
  }

  metaData() {
    return {
      lessonId: this.id,
      lessonTitle: this.title,
      lessonState: LessonProgressTypeLabel[this.progress],
    };
  }

  getTotalTimeFormatted() {
    return formatMinutes(this.totalTimeInMinutes);
  }

  isNotStarted() {
    return this.progress === LessonProgressType.notStarted;
  }

  isStarted() {
    return (
      this.progress === LessonProgressType.started ||
      this.progress === LessonProgressType.InProgress
    );
  }

  isCompleted() {
    return this.progress === LessonProgressType.completed;
  }

  isWebinar() {
    return this.type === LessonType.webinar;
  }

  isPractical() {
    return this.type === LessonType.practical;
  }

  isAssessment() {
    return this.type === LessonType.assessment;
  }

  isArticle() {
    return this.type === LessonType.article;
  }

  isVideo() {
    return this.type === LessonType.video;
  }

  getTypeIcon() {
    return `lesson_${this.type}`;
  }
}
